import * as React from 'react';

const underlineStyling =
  " lg:after:content-['_'] lg:after:h-0 after:bg-primary after:absolute after:left-0 after:right-2 after:-bottom-[10px] after:transition-all after:ease-in-out";
const hoverStyling = ' hover:text-primary lg:hover:after:h-1';

const mainStylingDisabled =
  'relative flex transition-all ease-in-out items-center text-grey-400 font-semibold text-b1 disabled';

const mainStyling =
  'relative flex transition-all ease-in-out items-center text-black font-semibold text-b1' +
  underlineStyling +
  hoverStyling;

const GlobalNavigationLink: React.FC<GlobalNavigationLinkProps> = ({
  text,
  link,
  linkTitle,
  isNewWindow = true,
  isDisabled,
  isMenuOpen,
  ...props
}) => {
  const linkTextElement = (
    <span
      className="flex h-full w-full text-nowrap px-7 py-6 text-left lg:-mx-1 lg:items-center lg:justify-center lg:p-0 lg:px-2"
      title={linkTitle}
      aria-disabled={isDisabled}
    >
      {text}
    </span>
  );

  const linkElement = (
    <a className="h-full w-full" href={link} target={isNewWindow ? '_blank' : ''}>
      {linkTextElement}
    </a>
  );

  return (
    <li
      className={`${isDisabled ? mainStylingDisabled : mainStyling} ${
        isMenuOpen
          ? 'absolute left-0 top-5 w-svw border-t bg-white shadow lg:relative lg:w-[unset] lg:border-t-0 lg:bg-inherit lg:shadow-none'
          : ''
        }`}
      {...props}
    >
      {linkElement}
    </li>
  );
};
GlobalNavigationLink.displayName = 'GlobalNavigationLink';

declare interface GlobalNavigationLinkProps {
  text: string;
  link: string;
  linkTitle?: string;
  tooltip?: string;
  isNewWindow?: boolean;
  isDisabled?: boolean;
  isMenuOpen?: boolean;
}

declare interface GlobalNavigationLinkCollection<GlobalNavigationLinkProps> {
  primaryNavLinks: GlobalNavigationLinkProps[];
  secondaryNavLinks: GlobalNavigationLinkProps[];
}

export { GlobalNavigationLink };
export type { GlobalNavigationLinkProps, GlobalNavigationLinkCollection };
